var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.707108 9.66L6.36396 4.00319","stroke":"#636363","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12.0215 9.66L6.36462 4.00316","stroke":"#636363","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ChevronUp.defaultProps = {"width":"13","height":"14","viewBox":"0 0 13 14","fill":"none"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
